import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionTitleSeparator from "hooks/form/blocks/useSectionTitleSeparator";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionTitleSeparatorForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, formHook } = useSectionTitleSeparator();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            setValue={setValue}
                                            value={form.text.it.text}
                                            path={"text.it.text"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            setValue={setValue}
                                            value={form.text.en.text}
                                            path={"text.en.text"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionTitleSeparatorForm;
